module.exports = __webpack_public_path__ + "static/media/login.04716058.png";